'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/9/24.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomePageSearchBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HomePageSearchBar, _Component);

  function HomePageSearchBar() {
    (0, _classCallCheck3.default)(this, HomePageSearchBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(HomePageSearchBar).call(this));

    _this.state = {
      value: ''
      // changeValue: false
    };
    return _this;
  }

  (0, _createClass3.default)(HomePageSearchBar, [{
    key: 'onHandleChange',
    value: function onHandleChange(event) {
      var changeSearchTypeToTrue = this.props.changeSearchTypeToTrue;

      changeSearchTypeToTrue();
      this.setState({
        value: event.target.value
      });
    }
  }, {
    key: 'search',
    // changeValue: true
    value: function search() {
      var input = this.refs.searchInput;
      var onSearch = this.props.onSearch;

      if (onSearch) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onSearch(input.value);
        window.scrollTo(0, sTop);
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.keyCode === 13) {
        this.search();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./HomePageSearchBar.scss');
      var _props = this.props;
      var placeholderTexts = _props.placeholderTexts;
      var defaultValue = _props.defaultValue;
      var changeValue = _props.changeValue;
      var value = this.state.value;

      var defaultInputValue = '';
      if (changeValue) {
        defaultInputValue = value;
      } else {
        defaultInputValue = defaultValue;
      }
      return _react2.default.createElement(
        'div',
        { style: { position: 'relative' } },
        _react2.default.createElement(
          'div',
          { className: styles.top },
          _react2.default.createElement(
            'div',
            { className: styles.so_iop },
            _react2.default.createElement(
              'a',
              { className: styles.so_fa, href: '' },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/find.png' })
            ),
            _react2.default.createElement('input', { className: styles.so_input, placeholder: placeholderTexts, type: 'text', ref: 'searchInput',
              value: defaultInputValue,
              onChange: this.onHandleChange.bind(this),
              onKeyDown: this.handleKeyDown.bind(this) })
          ),
          _react2.default.createElement(
            'span',
            { href: '', className: styles.so_btn, onClick: this.search.bind(this) },
            '搜索'
          )
        )
      );
    }
  }]);
  return HomePageSearchBar;
}(_react.Component), _class.propTypes = {
  onSearch: _react.PropTypes.func,
  placeholderTexts: _react.PropTypes.string,
  defaultValue: _react.PropTypes.string,
  changeValue: _react.PropTypes.bool,
  changeSearchTypeToTrue: _react.PropTypes.func
}, _temp);
exports.default = HomePageSearchBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HomePageSearchBar/HomePageSearchBar.js
 ** module id = 1356
 ** module chunks = 0
 **/